<template>
  <div
    class="group-seckill"
    v-if="groupSeckillData || groupSeckillOther.length > 0"
  >
    <article
      v-if="groupSeckillData && groupSeckillData.type"
      @click="toGroupandseckill"
    >
      <h4>拼团·秒杀</h4>
      <div class="img-ui">
        <img v-lazy="$$viewImage(groupSeckillData.picUrl, 400, 400)" alt="" />
      </div>
      <div class="desc-gc">
        <p>
          <span class="icon">&yen;</span
          ><span class="price">{{ groupSeckillData.price / 100 }}</span>
        </p>
        <i :class="`type-${groupSeckillData.type}`"></i>
      </div>
    </article>
    <ul
      v-if="groupSeckillOther && groupSeckillOther.length > 0"
      :class="{ nogs: !groupSeckillData.type }"
    >
      <li
        v-for="(item, index) in groupSeckillOther.slice(0, 2)"
        @click="toUrl(item.url)"
        :key="index"
      >
        <div class="content-ui">
          <p class="name">{{ item.title }}</p>
          <p class="desc">{{ item.desc }}</p>
        </div>
        <div class="img-ui">
          <img v-lazy="item.img" alt="" />
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { pushHref } from '@/plugins/jump'

export default {
  props: {
    groupSeckillData: {
      type: Object,
      default() {
        return {}
      }
    },
    groupSeckillOther: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    toUrl(url) {
      if (!url) return
      let {
        query: { swt }
      } = this.$route
      let _url = url
      if (swt) {
        _url += (url.indexOf('?') !== -1 ? '&' : '?') + `swt=${swt}`
      }
      location.href = _url
    },
    toGroupandseckill() {
      pushHref({ name: 'groupandseckill', query: { swt: 1 } })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.group-seckill {
  background-color: #fff;
  border-radius: rem(16px);
  margin: rem(30px);

  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);

  display: flex;
  align-items: stretch;
  > article {
    width: rem(327px);
    flex: auto;
    padding: 0 rem(36px);
    padding-right: 0;
    background: url('~@/assets/images/home/bg-group_sckill@3x.png') no-repeat
      rem(12px) center;
    background-size: rem(309px) auto;

    h4 {
      line-height: rem(68px);
      font-weight: bold;
      font-size: rem(32px);
      color: #333333;

      margin-top: rem(12px);
    }
    .img-ui {
      width: rem(260px);
      height: rem(158px);
      overflow: hidden;
      border-radius: rem(8px);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .desc-gc {
      padding-top: rem(20px);
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        color: #ff397e;
        display: flex;
        align-items: baseline;
        padding-right: rem(12px);
        .icon {
          font-size: rem(24px);
          line-height: rem(24px);
        }

        .price {
          font-size: rem(32px);
          line-height: rem(42px);
          font-weight: 600;
        }
      }
      i {
        display: block;
        width: rem(67px);
        height: rem(24px);
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center right;
        &.type-1 {
          background-image: url('~@/assets/images/home/icon_msj@3x.png');
        }
        &.type-2 {
          background-image: url('~@/assets/images/home/icon_ptj@3x.png');
        }
      }
    }
  }
  > ul {
    flex: auto;
    display: flex;
    width: rem(364px);
    flex-direction: column;
    overflow: hidden;
    @include border(left);
    &.nogs {
      flex-direction: row;
      @include border(left, #fff, 0);
      li {
        padding-top: rem(28px);
        padding-bottom: rem(28px);
        @include border(left);
        &:first-child {
          @include border(left, #fff, 0);
        }
      }
    }
    li {
      flex: 1;
      padding: rem(22px) rem(24px);
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
      .content-ui {
        background-repeat: no-repeat;
        background-size: rem(120px) auto;
        background-position: right top;
        height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        overflow: hidden;
        flex: auto;

        .name {
          font-size: rem(32px);
          color: #000000;
          font-weight: bold;
          max-width: 100%;
          @include ellicpsis;
        }
        .desc {
          font-size: rem(24px);
          color: #999;
          padding-top: rem(12px);
          max-width: 100%;
          @include ellicpsis;
        }
      }
      .img-ui {
        width: rem(120px);
        height: rem(120px);
        overflow: hidden;
        flex: none;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
